import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/vercel/path0/layouts/app.vue")),
  article: defineAsyncComponent(() => import("/vercel/path0/layouts/article.vue")),
  chat: defineAsyncComponent(() => import("/vercel/path0/layouts/chat.vue")),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue"))
}